import { useMemo } from 'react'
import { ICollateral } from '../types'
import useCollaterals from './useCollaterals'

export const useCollateralById = (id?: number) => {
  const collaterals = useCollaterals()

  return useMemo(() => (id ? collaterals?.find(item => item.id === id) : ({} as ICollateral)), [id, collaterals])
}
